import React,{useState} from 'react'
import * as PR from "../../prime-modules/index";
import { checkDataSize, formatCurrency, getOptionBundle, getPlanBundleTitle, randomIdGenerator, showDate } from '../../utils/reuse';
import { ICCID } from '../../utils/localstore';
import { useMutation, useQuery } from 'react-query';
import { changeSubscriptionApi, getPlansDropDownAPI, subscriptionPlans } from '../../services/api';
import { useToast } from '../../context/ToastContext';
import { billingAddress, deviceData } from '../payment/helper';
import { useSelector } from 'react-redux';

const ChangeSubscription = ({labelsIot,data,onHide,refetch})=> {
    const { firstName, email, phone } = useSelector((state) => state.auth.userData);
    const { showToast } = useToast()
    const [updateSubscription, setUpdateSubscription] = useState(false);
    const [selectedDataPackage, setSelectedDataPackage] = useState('');
    const [selectedPlanPackage, setSelectedPlanPackage] = useState('');

    const request = (data) => ({
        ...deviceData,
       iccid:localStorage.getItem(ICCID),
        contactInfo: {
          firstName,
          email,
          lastName: "",
          phone
        },
        billingAddress,
        orderSummary: {
          dataPlans: [
            {
              name: data.name,
              description: data.description,
              quantity: 1,
              price: +data.price,
              promoCode: ""
            }
          ],
          totalOrderAmount: +data.price
        },
        paymentGateway: "Stripe",
        paymentMethodId: randomIdGenerator() ,
      })

    let filterList = [];
    let planOptions = []
    let planPrice = ''
    let selectedBundle = {}

    const {data:dropDownData  } = useQuery(['PlansDropDownAPI'],getPlansDropDownAPI.bind(null,localStorage.getItem(ICCID)),{
        //staleTime: 300000, // 5 minutes in milliseconds
      });

      const { mutate: updateDeviceSubscription, isLoading: updateDeviceLoading } = useMutation(changeSubscriptionApi, {
        onSuccess: (o) => {
            showToast('success',labelsIot?.LBLI0194 || "Your subscription plan will be updated shortly.")
            onHide()
            refetch()
          
        },
        onError: (o) => showToast("error", o?.message)
      })
    
      let currentActiveBundle = data.find(item=>item.iccid === localStorage.getItem(ICCID))?.activeBundlesData[0]
      let getActiveDevice = data.find(item=>item.iccid === localStorage.getItem(ICCID))
      let ICCIDData = data.find(item=>item.iccid === localStorage.getItem(ICCID))
      let firstDropDownPlanValue = currentActiveBundle?.description
      let dataAmount = checkDataSize(currentActiveBundle?.totalData).replace(" ","").trim()
      let currentUserDataPlan = dataAmount === 'OKB' ?  "Unlimited" : dataAmount
      if (!!dropDownData) {
        filterList = dropDownData?.dataAmountForDisplay?.map(item => {
          return({
          name: item,
          value: item,
          disabled: currentUserDataPlan === item && selectedPlanPackage === firstDropDownPlanValue?.split(" ")[0]
        })});

        planOptions = dropDownData?.duration?.map(item => {
          const optionName = getOptionBundle(getPlanBundleTitle(item, "", labelsIot)).replace("Bundle", "").trim()
          return {
            name: optionName,
            value: optionName,
            disabled: currentUserDataPlan === selectedDataPackage && firstDropDownPlanValue?.split(" ")[0] === optionName
          };
        });
      }
      const {data:plans  } = useQuery(
        ['Plans', selectedDataPackage, localStorage.getItem(ICCID)],
        subscriptionPlans,
        {enabled: selectedPlanPackage && selectedDataPackage ? true : false});
        if(!!plans){
          selectedBundle = plans.filter(item=> getOptionBundle(getPlanBundleTitle(item?.duration,"",labelsIot)).replace("Bundle","").trim() === selectedPlanPackage.trim())[0]
          planPrice = selectedBundle?.price
        }

        const handleChangePlan = () =>{
          if(!selectedBundle) return
          let payload = request(selectedBundle)
          updateDeviceSubscription(payload);
        }

      const headerElement = (
        <h2><span><i className="pi pi-refresh"></i></span>{labelsIot?.LBLI0197 || "Update subscription"} </h2>
      );
        
  return ( <>
    <div className="cancel-subscription">
    <p>{labelsIot?.LBLI0189 || "You are currently subscribed to"}<span className="font-bold"> {firstDropDownPlanValue?.split(" ")[0] + " " + firstDropDownPlanValue?.split(" ")[1]} </span>{labelsIot?.LBLI0190 || "with a data limit of "}<span className="font-bold">          
              {(!currentActiveBundle?.isUnlimited) ? ` ${checkDataSize(currentActiveBundle?.totalData) || "N/A"} / ${labelsIot.LBLI0165} ` 
                : ` ${labelsIot?.LBLI0171} ${labelsIot?.LBLI0172}`} </span>{labelsIot?.LBLI0191 || "which expires on"}<span className="font-bold"> {showDate(ICCIDData?.subscriptionNextDue)}.</span></p>
    <p>{labelsIot?.LBLI0192 || "Easily update your subscription to match your data needs. Choose a new plan from the available options below and enjoy uninterrupted connectivity."}</p>
    <div className="grid change-subscription-form">
      <div className="col-12">
        <p><span className="font-bold"> {labelsIot?.LBLI0195 || "Choose your subscription plan"} </span></p>
      </div>
      <div className="col-12 md:col-6">
        <PR.Dropdown value={selectedPlanPackage} onChange={(e)=>setSelectedPlanPackage(e.value)} options={planOptions} optionLabel="name" 
        placeholder={labelsIot?.LBLI0198 || "Select a Bundle"} className="select-plan-dropdown" panelClassName="data-dropdown-panel" />
      </div>
      <div className="col-12 md:col-6">
        <PR.Dropdown value={selectedDataPackage} onChange={(e)=>setSelectedDataPackage(e.value)} options={filterList} optionLabel="name" 
        placeholder={labelsIot?.LBLI0199 || "Select a Data"} className="select-plan-dropdown" panelClassName="data-dropdown-panel" />
      </div>
    </div>

   {!!planPrice ? <p className='mt-2'>{labelsIot?.LBLI0196 || "Your updated pricing for the plan is"} 
    <span className="font-bold"> {formatCurrency(selectedBundle?.priceCurrency, planPrice)} </span> {labelsIot?.LBLI0193||"and any difference in pricing will be either charged to your card or adjusted towards your future invoices."}</p> : null}
    
    <div className="card flex flex-column">
      <PR.Button disabled={updateDeviceLoading || !planPrice} onClick={() => setUpdateSubscription(true)} label={labelsIot?.LBLI0197 || "Update subscription"} className="device-confirm-button change-subscription-button" />
    </div>
  </div>
  <PR.Dialog
    visible={updateSubscription}
    onHide={() => {if (!updateSubscription) return; setUpdateSubscription(false); }}
    draggable={false}
    baseZIndex={1}
    header={headerElement}
    maskClassName="add-device-dialog update-subscription"
  >
 <div className="cancel-subscription">
  <div className="col-12 p-0 mt-3">
    <p className="text-md leading-relaxed text-xl">
      {labelsIot?.LBLI0206 || "Please confirm that you want to update the subscription"}{" "}
      {getActiveDevice?.tag ? (
        <>{labelsIot?.LBLI0210 || "of"}<span className="font-semibold"> {getActiveDevice.tag}</span></>
      ) : (
       <> 
       {labelsIot?.LBLI0209 || "your device with"} <span className="font-semibold">
          {labelsIot?.LBLI0018}: {getActiveDevice?.iccid}
        </span></>
      )}
      {" "}{labelsIot?.LBLIO207 || "to"}{" "}
      <span className="font-semibold">
        {selectedDataPackage} {labelsIot?.LBLIO208 || "per month billed"} {selectedPlanPackage.trim()}?
      </span>
    </p>

    <PR.Button
      disabled={updateDeviceLoading || !planPrice}
      loading={updateDeviceLoading || !planPrice}
      onClick={handleChangePlan}
      label={labelsIot?.LBLI0201 || "Yes, I'm sure"}
      className="device-confirm-button change-subscription-button"
    />
  </div>
</div>

  </PR.Dialog>
 </> )
}

export default ChangeSubscription